<template>
    <div>
        <Pane title="重新提交设计会签" :showRemarks="false">
            <template>重新发起设计会签流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 16 }">
                <a-form
                    :model="form"
                    layout="horizontal"
                    :colon="false"
                    label-align="right"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 12 }"
                >
                    <div class="title" style="margin-top: 0">基本信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" style="margin-bottom: 12px;background:#f9f9f9;margin: 0 auto;padding: 12px;">
                            <a-col :span="12">
                                <a-form-item label="工程名称">
                                    <a-input v-model="form.projectName" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="工程编号">
                                    <a-input v-model="form.projectCode" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目阶段">
                                    <a-select v-model="form.phaseCode" disabled>
                                        <a-select-option v-for="item in designPhaseList" :key="item.value" :value="String(item.value)">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="提出专业">
                                    <a-select v-model="form.fromMajorCode" disabled>
                                        <a-select-option v-for="item in majorList" :key="item.value" :value="String(item.value)">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计编号">
                                    <a-input v-model="form.designNo" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="发起人">
                                    <EmployeeSelector
                                        @change="handleInitiatorChange"
                                        :value="form.initiatorId ? [{ name: form.initiatorName, userId: form.initiatorId }] : []"
                                    >
                                        <a-button block style="text-align: left;" disabled>{{ form.initiatorName || "请选择发起人" }}</a-button>
                                    </EmployeeSelector>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="title">会签成果</div>
                    <div class="wrapper">
                        <div style="display: flex; justify-content: flex-end; margin-bottom: 8px;">
                            <a-button icon="plus" @click="handleAddResult">新增</a-button>
                            <a-button icon="delete" style="margin-left: 8px;" :disabled="selectedResultRowKeys.length === 0" @click="handleDeleteResult">删除</a-button>
                        </div>
                        <a-table
                            :data-source="resultFiles"
                            :columns="resultColumns"
                            :row-key="record => record._rowKey || record.fileId || record.id"
                            :pagination="false"
                            bordered
                            :row-selection="{ selectedRowKeys: selectedResultRowKeys, onChange: onResultSelectChange }"
                            :expandedRowKeys="expandedRowKeys"
                            @expand="onExpand"
                        >
                            <template slot="expandedRowRender" slot-scope="record">
                                <a-table
                                    :data-source="record.selectedPages"
                                    :columns="pageColumns"
                                    :row-key="record => record.id || record.pageName + '_' + record.pageNumber"
                                    :pagination="false"
                                    bordered
                                    size="small"
                                    :row-selection="getPageRowSelection(record._rowKey)"
                                >
                                    <template slot="pageName" slot-scope="text, pageRecord">
                                        <a v-if="getAttachmentUrl(pageRecord.attachment)" @click.prevent="previewPdf(getAttachmentUrl(pageRecord.attachment), text)" class="file-link">{{ text }}</a>
                                        <span v-else>{{ text }}</span>
                                    </template>
                                </a-table>
                            </template>
                            <template slot="majorCode" slot-scope="text">
                                {{ getMajorName(text) }}
                            </template>
                            <template slot="phaseCode" slot-scope="text">
                                {{ getPhaseName(text) }}
                            </template>
                        </a-table>
                    </div>
                    <div class="title">会签人员</div>
                    <div class="wrapper">
                        <a-button type="dashed" style="width: 100%; margin-bottom: 12px;" icon="plus" @click="addSigner" :disabled="!canAddSigner">添加会签人员</a-button>
                        <a-table :data-source="form.signers" :columns="signerColumns" row-key="rowKey" :pagination="false" bordered size="small">
                            <template slot="majorCode" slot-scope="text, record">
                                <a-select v-model="record.majorCode" placeholder="请选择专业" style="width: 100%" @change="val => handleMajorSelect(record, val)" :class="{ 'required-error': !record.majorCode && showRequiredError }">
                                    <a-select-option v-for="item in getMajorOptions()" :key="item.value" :value="String(item.value)">{{ item.name }}</a-select-option>
                                </a-select>
                            </template>
                            <template slot="signerName" slot-scope="text, record">
                                <a-select mode="multiple" v-model="record.selectedSignerIds" placeholder="请选择会签人" style="width: 100%" :class="{ 'required-error': (!record.selectedSignerIds || record.selectedSignerIds.length === 0) && showRequiredError }">
                                    <a-select-option v-for="item in (record.signerOptions || [])" :key="item.id" :value="String(item.id)">{{ item.name }}</a-select-option>
                                </a-select>
                            </template>
                            <template slot="remark" slot-scope="text, record">
                                <a-input v-model="record.remark" placeholder="请输入备注" />
                            </template>
                            <template slot="action" slot-scope="text, record, index">
                                <a-button type="link" style="color: #ff4d4f" @click="removeSigner(index)">删除</a-button>
                            </template>
                        </a-table>
                    </div>



                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>

        <a-modal title="选择会签" v-model="addResultVisible" width="800px" @ok="handleAddResultOk" @cancel="handleAddResultCancel" destroyOnClose>
            <a-table
                :columns="addResultColumns"
                :data-source="availableCountersignList"
                :row-key="record => record.id || record.signCode"
                :pagination="addResultPagination"
                @change="handleAddResultTableChange"
                :loading="addResultLoading"
                bordered
                :row-selection="{ selectedRowKeys: addResultSelectedKeys, onChange: onAddResultSelectChange }"
            >
                <template slot="approveStatusName" slot-scope="text">
                    <approve-status-tag :status="text" :dictKey="'cosys.countersign'" />
                </template>
                <template slot="fromMajorCodeName" slot-scope="text">
                    {{ getDictName('cosys.major', text) }}
                </template>
                <template slot="phaseCodeName" slot-scope="text">
                    {{ getDictName('cosys.designPhase', text) }}
                </template>
            </a-table>
        </a-modal>
    </div>
</template>

<script>
import EmployeeSelector from "@/components/employee-selector";
import ApproveStatusTag from '@/components/columns/ApproveStatusTag.vue';
import { dictMixin } from '@/utils/columns'
import { getDesignResultFiles, fetchCountersignList, fetchCountersignDetailBySignCode, listPagesByFileId, resubmitCountersign } from "@/api/project-design/countersign";
import { getDesignPlanPersonnel } from "@/api/project-design/transfer";
import { fetchSimplePlanPersonnel } from "@/api/project-plan/simple-plan";
import { fetchPrjTaskPhaseSummary } from "@/api/project-execute/result";
import { mapMutations, mapGetters } from "vuex";

export default {
    name: "DesignCountersignReapply",
    components: { EmployeeSelector, ApproveStatusTag },
    mixins: [dictMixin],
    data() {
        return {
            loading: false,
            submitting: false,
            id: "",
            taskId: "",
            instanceId: "",
            showRequiredError: false,
            resultFiles: [],
            designResultFiles: [],
            selectedResultRowKeys: [],
            selectedPageKeysMap: {},
            expandedRowKeys: [],
            existingCountersignIds: [],
            addResultVisible: false,
            addResultSelectedKeys: [],
            availableCountersignList: [],
            addResultPagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                pageSizeOptions: ['10', '50', '100', '200'],
                showTotal: total => `共 ${total} 条`
            },
            addResultLoading: false,
            localPlanProject: null,
            form: {
                projectName: "",
                projectCode: "",
                phaseCode: "",
                fromMajorCode: "",
                designNo: "",
                initiatorName: "",
                initiatorId: "",
                signers: [],
                approveStatus: "",
                phaseId: "",
            },
            signerColumns: [
                { title: '专业 *', dataIndex: 'majorCode', width: 150, scopedSlots: { customRender: 'majorCode' } },
                { title: '会签人 *', dataIndex: 'signerName', width: 150, scopedSlots: { customRender: 'signerName' } },
                { title: '备注', dataIndex: 'remark', width: 200, scopedSlots: { customRender: 'remark' } },
                { title: '操作', key: 'action', width: 80, scopedSlots: { customRender: 'action' } },
            ],
            resultColumns: [
                { title: '成果名称', dataIndex: 'resultName', ellipsis: true },
                { title: '成果编号', dataIndex: 'resultNo', width: 120 },
                { title: '专业', dataIndex: 'majorCode', width: 100, scopedSlots: { customRender: 'majorCode' } },
                { title: '阶段', dataIndex: 'phaseCode', width: 100, scopedSlots: { customRender: 'phaseCode' } },
                { title: '文件名称', dataIndex: 'fileName', ellipsis: true },
            ],
            pageColumns: [
                { title: '页面名称', dataIndex: 'pageName', ellipsis: true, scopedSlots: { customRender: 'pageName' } },
                { title: '页码', dataIndex: 'pageNumber', width: 80 },
                { title: '页数', dataIndex: 'pageCount', width: 80 },
                { title: '图号', dataIndex: 'drawingNo', width: 120 },
            ],
            addResultColumns: [
                { title: '流程状态', dataIndex: 'approveStatus', width: 100, scopedSlots: { customRender: 'approveStatusName' } },
                { title: '工程名称', dataIndex: 'projectName', ellipsis: true },
                { title: '设计编号', dataIndex: 'designNo', width: 120 },
                { title: '成功名称', dataIndex: 'resultName', width: 120 },
                { title: '提出专业', dataIndex: 'fromMajorCode', width: 100, scopedSlots: { customRender: 'fromMajorCodeName' } },
                { title: '设计阶段', dataIndex: 'phaseCode', width: 100, scopedSlots: { customRender: 'phaseCodeName' } },
                { title: '发起人', dataIndex: 'initiatorName', width: 100 },
            ],
        };
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        currentPlanProject() {
            return this.localPlanProject;
        },
        currentMajor() {
            if (!this.localPlanProject || !this.localPlanProject.majors) return '';
            return this.localPlanProject.majors.split(',')[0] || '';
        },
        majorList() {
            return (this.findDataDict && this.findDataDict("cosys.major")) || [];
        },
        majorTabs() {
            if (!this.localPlanProject || !this.localPlanProject.majors) return [];
            const codes = this.localPlanProject.majors.split(',').filter(Boolean);
            return codes.map(code => {
                const found = this.majorList.find(d => String(d.value) === String(code));
                return { key: code, name: found ? found.name : code };
            });
        },
        availableMajorList() {
            return this.majorTabs
                .filter(item => String(item.key) !== String(this.form.fromMajorCode))
                .map(item => ({ value: item.key, name: item.name }));
        },
        canAddSigner() {
            const selectedMajors = new Set((this.form.signers || []).map(s => String(s.majorCode)).filter(Boolean));
            return this.availableMajorList.some(item => !selectedMajors.has(String(item.value)));
        },
        designPhaseList() {
            return (this.findDataDict && this.findDataDict("cosys.designPhase")) || [];
        },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }

        this.fetchDetail();
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        async fetchDetail() {
            this.loading = true;
            const extra = this.$store.state.approval.detail?.extra || {};
            this.form.projectName = extra.projectName || "";
            this.form.projectCode = extra.projectCode || "";
            this.form.phaseCode = extra.phaseCode || "";
            this.form.fromMajorCode = extra.fromMajorCode || "";
            this.form.designNo = extra.designNo || "";
            this.form.initiatorName = extra.initiatorName || "";
            this.form.initiatorId = extra.initiatorId || "";
            this.form.approveStatus = extra.approveStatus || "";
            this.form.phaseId = extra.phaseId || "";
            this.form.signers = this.transformSigners(extra.signers);

            const normalize = (rf) => {
                const resultId = rf.resultId || rf.id || rf.fileId || (Date.now() + Math.random()).toString();
                return {
                    ...rf,
                    resultId,
                    _rowKey: rf.fileId || rf.id || resultId,
                    selectedPages: rf.selectedPages || [],
                    _pagesLoaded: !!rf.selectedPages,
                };
            };

            console.log("extra:::",extra)

            if (extra.designResultFiles && extra.designResultFiles.length) {
                this.designResultFiles = extra.designResultFiles;
                this.resultFiles = extra.designResultFiles.map(normalize);
                this.existingCountersignIds = [...new Set(extra.designResultFiles.map(rf => rf.countersignId))];
                // 若有 signCode，则由 loadResultFiles 根据 detail.designResultFiles 决定选中状态，不在此处全选
                if (!extra.signCode) {
                    this.selectAllResults();
                }
            }

            // else if (extra.designResultIds) {
            //     const ids = extra.designResultIds.split(',').filter(Boolean);
            //     this.existingCountersignIds = ids;
            //     if (ids.length) {
            //         this.loadResultFiles();
            //     }
            // }
            if (extra.signCode) {
                try {

                    const detail = await fetchCountersignDetailBySignCode(extra.signCode);

                    this.form.projectName = detail.projectName || this.form.projectName;
                    this.form.projectCode = detail.projectCode || this.form.projectCode;
                    this.form.phaseCode = detail.phaseCode || this.form.phaseCode;
                    this.form.fromMajorCode = detail.fromMajorCode || this.form.fromMajorCode;
                    this.form.designNo = detail.designNo || this.form.designNo;
                    this.form.approveStatus = detail.approveStatus || this.form.approveStatus;
                    this.form.phaseId = detail.phaseId || this.form.phaseId;
                    this.form.signCode = detail.signCode || extra.signCode;
                    if (detail.initiatorName) {
                        this.form.initiatorName = detail.initiatorName;
                        this.form.initiatorId = detail.initiatorId;
                    } else if (detail.createName) {
                        this.form.initiatorName = detail.createName;
                    }
                    if (detail.signers && detail.signers.length) {
                        this.form.signers = this.transformSigners(detail.signers);
                    }

                    if (detail.phaseId) {
                        try {
                            const summary = await fetchPrjTaskPhaseSummary(detail.phaseId);
                            if (summary) {
                                const projectCode = detail.projectCode || '';
                                const prjNo = projectCode.split('-')[0] || '';
                                this.localPlanProject = {
                                    id: summary.id,
                                    phaseId: summary.id,
                                    code: projectCode,
                                    name: summary.name,
                                    prjNo: prjNo,
                                    prjName: summary.name,
                                    phaseCode: summary.phaseCode,
                                    phaseName: summary.phaseName,
                                    manageLevel: summary.manageLevel,
                                    prjCategory: summary.prjCategory,
                                    designCode: summary.designCode,
                                    customerName: summary.customerName,
                                    mainDeptName: summary.mainDeptName,
                                    majors: summary.majors || '',
                                    noticeId: null,
                                    requireFinishDate: summary.planEndDate || null,
                                    planPrjLeaderId: null,
                                    planPrjLeaderName: null,
                                    mainDeptId: null,
                                    createAt: null,
                                };
                            }
                        } catch (e) {
                            console.warn('fetchPrjTaskPhaseSummary failed', e);
                        }
                    }

                    await this.loadResultFiles(detail);
                } catch (e) {
                    console.warn('fetchCountersignDetailBySignCode failed, using extra data', e);
                }
            }
            this.loading = false;
        },
        handleInitiatorChange(arr) {
            if (arr.length) {
                this.form.initiatorName = arr[0].name;
                this.form.initiatorId = arr[0].userId;
            } else {
                this.form.initiatorName = '';
                this.form.initiatorId = '';
            }
        },
        addSigner() {
            if (!this.form.signers) this.$set(this.form, 'signers', []);
            this.form.signers.push({ majorCode: '', selectedSignerIds: [], signerOptions: [], remark: '', rowKey: Date.now() + Math.random() });
        },
        removeSigner(index) {
            this.form.signers.splice(index, 1);
        },
        async handleMajorSelect(record, majorCode) {
            record.majorCode = majorCode;
            record.selectedSignerIds = [];
            record.signerOptions = [];
            if (!majorCode) return;
            try {
                const planProject = this.currentPlanProject;
                const phaseId = this.form.phaseId || (planProject && planProject.phaseId);
                if (!phaseId) return;
                const isSimple = planProject && planProject.prjCategory === 'simple';
                const res = isSimple
                    ? await fetchSimplePlanPersonnel({ majorCode, phaseId })
                    : await getDesignPlanPersonnel({ majorCode, phaseId });
                if (res) {
                    const fromMajor = (res.majorPersonnels || []).find(m => m.majorCode === majorCode);
                    if (fromMajor) {
                        const ids = (fromMajor.majorLeaderIds || '').split(',').filter(Boolean);
                        const names = (fromMajor.majorLeaderNames || '').split(',').filter(Boolean);
                        record.signerOptions = names.map((name, i) => ({ id: (ids[i] || '').trim(), name }));
                        record.selectedSignerIds = ids.map(id => String(id).trim()).filter(Boolean);
                    }
                }
            } catch (e) {
                console.error('获取人员配置失败', e);
            }
        },
        getMajorOptions() {
            return this.majorTabs.map(item => ({ value: item.key, name: item.name }));
        },
        transformSigners(signers) {
            const map = {};
            (signers || []).forEach(s => {
                const key = s.majorCode || '__none__';
                if (!map[key]) {
                    map[key] = { majorCode: s.majorCode || '', selectedSignerIds: [], signerOptions: [], remark: s.remark || '' };
                }
                if (s.signerId) {
                    const idStr = String(s.signerId);
                    if (!map[key].selectedSignerIds.includes(idStr)) {
                        map[key].selectedSignerIds.push(idStr);
                        map[key].signerOptions.push({ id: idStr, name: s.signerName || '' });
                    }
                }
            });
            return Object.values(map).map(s => ({ ...s, rowKey: Date.now() + Math.random() }));
        },
        async loadResultFiles(detail) {
            try {
                console.log("loadResultFiles:::detail::",detail)
                const res = await getDesignResultFiles({ countersignIds: [detail.id] });
                this.resultFiles = Array.isArray(res) ? res.map(rf => {
                    const resultId = rf.resultId || rf.id || rf.fileId || (Date.now() + Math.random()).toString();
                    return {
                        ...rf,
                        resultId,
                        _rowKey: rf.fileId || rf.id || resultId,
                        selectedPages: rf.selectedPages || [],
                        _pagesLoaded: !!rf.selectedPages,
                    };
                }) : [];

                // 优先使用 detail.designResultFiles（fetchCountersignDetailBySignCode 返回）作为回显依据
                if (detail.designResultFiles && detail.designResultFiles.length) {
                    this.designResultFiles = detail.designResultFiles;
                }
                const designResultFiles = detail.designResultFiles || this.designResultFiles || [];

                // 仅按 fileId 精确匹配（一个成果可有多个文件，resultId 过宽会导致整组成果被选中）
                const existingFileIds = new Set(designResultFiles.map(df => df.fileId).filter(Boolean));

                const isExisting = r => !!(r.fileId && existingFileIds.has(r.fileId));

                // 清空旧的选中状态，避免残留
                this.selectedResultRowKeys = [];
                this.selectedPageKeysMap = {};

                // 只选中 designResultFiles 中存在的文件
                this.selectedResultRowKeys = this.resultFiles
                    .filter(r => isExisting(r))
                    .map(r => r._rowKey);

                // 设置页面选中状态
                this.resultFiles.forEach(r => {
                    if (isExisting(r)) {
                        if (r.selectedPages && r.selectedPages.length) {
                            this.$set(this.selectedPageKeysMap, r._rowKey, r.selectedPages.map(p => p.id));
                        } else {
                            this.$set(this.selectedPageKeysMap, r._rowKey, []);
                        }
                    }
                });


            } catch (e) {
                this.resultFiles = [];
                console.error(e);
            }
        },
        selectAllResults() {
            this.selectedResultRowKeys = this.resultFiles.map(r => r._rowKey);
            this.resultFiles.forEach(r => {
                if (r.selectedPages && r.selectedPages.length) {
                    this.$set(this.selectedPageKeysMap, r._rowKey, r.selectedPages.map(p => p.id));
                } else {
                    this.$set(this.selectedPageKeysMap, r._rowKey, []);
                }
            });
        },
        onResultSelectChange(keys) {
            const prevKeys = this.selectedResultRowKeys;
            const added = keys.filter(k => !prevKeys.includes(k));
            const removed = prevKeys.filter(k => !keys.includes(k));
            added.forEach(rowKey => {
                const record = this.resultFiles.find(r => r._rowKey === rowKey);
                if (record && record.selectedPages && record.selectedPages.length) {
                    this.$set(this.selectedPageKeysMap, rowKey, record.selectedPages.map(p => p.id));
                }
            });
            removed.forEach(rowKey => {
                this.$delete(this.selectedPageKeysMap, rowKey);
            });
            this.selectedResultRowKeys = keys;
        },
        getPageRowSelection(rowKey) {
            return {
                selectedRowKeys: this.selectedPageKeysMap[rowKey] || [],
                onChange: (keys) => {
                    this.$set(this.selectedPageKeysMap, rowKey, keys);
                }
            };
        },
        getRowKey(record) {
            return record._rowKey || record.fileId || record.id || (record.countersignId || '') + '_' + (record.fileId || '');
        },
        async onExpand(expanded, record) {
            const key = this.getRowKey(record);
            if (expanded) {
                this.expandedRowKeys.push(key);
                if (!record._pagesLoaded && record.fileId) {
                    try {
                        const pages = await listPagesByFileId(record.fileId);
                        this.$set(record, 'selectedPages', Array.isArray(pages) ? pages : []);
                        this.$set(record, '_pagesLoaded', true);
                        if (this.selectedResultRowKeys.includes(key)) {
                            this.$set(this.selectedPageKeysMap, key, (Array.isArray(pages) ? pages : []).map(p => p.id));
                        }
                    } catch (e) {
                        this.$set(record, 'selectedPages', []);
                        this.$set(record, '_pagesLoaded', true);
                        console.error(e);
                    }
                }
            } else {
                const idx = this.expandedRowKeys.indexOf(key);
                if (idx > -1) this.expandedRowKeys.splice(idx, 1);
            }
        },
        handleAddResult() {
            this.addResultVisible = true;
            this.addResultSelectedKeys = [];
            this.addResultPagination.current = 1;
            this.fetchAvailableCountersignList();
        },
        async fetchAvailableCountersignList() {
            this.addResultLoading = true;
            try {
                const p = this.currentPlanProject;
                const params = {
                    pageNum: this.addResultPagination.current,
                    pageSize: this.addResultPagination.pageSize,
                    phaseId: (p && p.phaseId) || undefined,
                    fromMajorCode: this.currentMajor || undefined,
                };
                const res = await fetchCountersignList(params);
                const existingIds = new Set(this.existingCountersignIds);
                this.availableCountersignList = (res.list || []).filter(r => !existingIds.has(r.id) && !existingIds.has(r.signCode) && ['Start', 'Cancel'].includes(r.approveStatus));
                this.addResultPagination.total = res.totalSize || 0;
            } catch (e) {
                this.availableCountersignList = [];
                console.error(e);
            } finally {
                this.addResultLoading = false;
            }
        },
        handleAddResultTableChange(newPagination) {
            this.addResultPagination.current = newPagination.current;
            this.addResultPagination.pageSize = newPagination.pageSize;
            this.fetchAvailableCountersignList();
        },
        onAddResultSelectChange(keys) {
            this.addResultSelectedKeys = keys;
        },
        async handleAddResultOk() {
            const newIds = this.addResultSelectedKeys.filter(id => !this.existingCountersignIds.includes(id));
            if (!newIds.length) {
                this.addResultVisible = false;
                return;
            }
            this.existingCountersignIds = [...this.existingCountersignIds, ...newIds];
            // await this.loadResultFiles();
            this.addResultVisible = false;
        },
        handleAddResultCancel() {
            this.addResultVisible = false;
        },
        handleDeleteResult() {
            const removeIds = new Set(this.selectedResultRowKeys);
            this.resultFiles = this.resultFiles.filter(r => !removeIds.has(r._rowKey));
            this.existingCountersignIds = [...new Set(this.resultFiles.map(r => r.countersignId))];
            this.selectedResultRowKeys = [];
            removeIds.forEach(id => {
                this.$delete(this.selectedPageKeysMap, id);
            });
        },
        getMajorName(code) {
            const found = this.majorList.find(d => String(d.value) === String(code));
            return found ? found.name : code;
        },
        getPhaseName(code) {
            const found = this.designPhaseList.find(d => String(d.value) === String(code));
            return found ? found.name : code;
        },
        getAttachmentInfo(attachmentStr) {
            if (!attachmentStr || typeof attachmentStr !== 'string') return null;
            try {
                const parsed = JSON.parse(attachmentStr);
                const url = parsed.url || '';
                const fullUrl = url.split('?')[0];
                const filename = fullUrl.substring(fullUrl.lastIndexOf('/') + 1);
                return { url, filename };
            } catch (e) {
                return null;
            }
        },
        getAttachmentUrl(attachmentStr) {
            const info = this.getAttachmentInfo(attachmentStr);
            return info ? info.url : '';
        },
        getAttachmentName(attachmentStr) {
            const info = this.getAttachmentInfo(attachmentStr);
            return info ? info.filename : '';
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        validateSigners() {
            const signers = this.form.signers || [];
            const hasEmpty = signers.some(s => !s.majorCode || !s.selectedSignerIds || s.selectedSignerIds.length === 0);
            this.showRequiredError = hasEmpty;
            return !hasEmpty;
        },
        submitReview() {
            if (!this.validateSigners()) {
                this.$message.error("请完善会签人员信息");
                return;
            }

            this.submitting = true;
            const signers = [];
            (this.form.signers || []).forEach(s => {
                if (s.majorCode && s.selectedSignerIds && s.selectedSignerIds.length > 0) {
                    s.selectedSignerIds.forEach(id => {
                        const opt = (s.signerOptions || []).find(o => String(o.id) === String(id));
                        signers.push({
                            majorCode: s.majorCode,
                            signerId: id,
                            signerName: opt ? opt.name : '',
                            remark: s.remark || '',
                        });
                    });
                }
            });

            const designResultFiles = this.resultFiles
                .filter(rf => this.selectedResultRowKeys.includes(rf._rowKey))
                .map(rf => {
                    let selectedPages = null;
                    const pageKeys = this.selectedPageKeysMap[rf._rowKey] || [];
                    if (pageKeys.length > 0) {
                        selectedPages = (rf.selectedPages || []).filter(p => p.id).map(p => ({ ...p }));
                    }
                    return {
                        countersignId: rf.countersignId,
                        resultId: rf.resultId,
                        resultNo: rf.resultNo || '',
                        subWbsNo: rf.subWbsNo || '',
                        subWbsName: rf.subWbsName || '',
                        phaseCode: rf.phaseCode || '',
                        majorCode: rf.majorCode || '',
                        resultName: rf.resultName || '',
                        auditEndDate: rf.auditEndDate || '',
                        fileId: rf.fileId || '',
                        fileName: rf.fileName || '',
                        pageCount: rf.pageCount || 0,
                        selectedPages,
                    };
                });

            const designResultIds = designResultFiles.map(rf => rf.countersignId).join(',');

            const data = {
                id: this.id,
                signCode: this.form.signCode,
                projectName: this.form.projectName,
                projectCode: this.form.projectCode,
                phaseCode: this.form.phaseCode,
                phaseId: this.form.phaseId,
                fromMajorCode: this.form.fromMajorCode,
                designNo: this.form.designNo,
                initiatorId: this.form.initiatorId,
                initiatorName: this.form.initiatorName,
                signers,
                designResultFiles,
                designResultIds,
            };

            resubmitCountersign(data)
                .then(() => {
                    this.$close(this.$route.path, "/approval/task");
                })
                .catch((e) => {
                    console.error("提交失败详情", e);
                    this.$message.error("提交失败");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    }
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}
.wrapper {
    background-color: #f9f9f9;
    padding-top: 24px;
    padding-bottom: 8px;
}
.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}
.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}
/deep/ .ant-table-tbody {
    background: #fff;
}
.required-error {
    border-color: #ff4d4f !important;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
}
</style>
